import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TRIAL_BALANCE_REPORT_API } from "./apiRoutes";

interface UseGetVendorTrialBalanceLineItemReportProps {
  vendorId: string;
  filter: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getVendorTrialBalanceLineItemReport = async (vendorId: string, filter: any) =>
  await axiosAuth.get(`${TRIAL_BALANCE_REPORT_API(filter?.communityId)}/vendor/${vendorId}/line-items?${new URLSearchParams(filter).toString()}`);

const useGetVendorTrialBalanceLineItemReport = ({
  vendorId,
  filter,
  queryParams,
}: UseGetVendorTrialBalanceLineItemReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["vendor-trial-balance-line-item-report", vendorId],
    queryFn: () => getVendorTrialBalanceLineItemReport(vendorId, filter),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!vendorId && (queryParams?.enabled ?? true),
  });
};

export default useGetVendorTrialBalanceLineItemReport;
